import script from "./CellValueChips.vue?vue&type=script&setup=true&lang=js"
export * from "./CellValueChips.vue?vue&type=script&setup=true&lang=js"

import "./CellValueChips.vue?vue&type=style&index=0&id=afa6b45a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa6b45a"]])

export default __exports__